import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import withAuth from '@shared/components/route/withAuth';

import { actions } from '@store/app';
import useActions from '@shared/hooks/useActions';
import AIProductList from '@pages/ai-product/list';
import AIProduct from '@pages/ai-product';
import { loadAiProduct, loadAiProductList } from '@store/ai-product/actions';
import { SiloStep } from '@pages/ai-product/silo-step/SiloStep';
import { BackgroundStep } from '@pages/ai-product/background-step/BackgroundStep';
import { VideoStep } from '@pages/ai-product/video-step/VideoStep';
import { TextStep } from '@pages/ai-product/text-step/TextStep';
import { ReviewStep } from '@pages/ai-product/review-step/ReviewStep';
import { DownloadStep } from '@pages/ai-product/download-step/DownloadStep';

export const AIProductsList = withAuth(() => {
  const dispatch = useDispatch();
  const { showMenu } = useActions(actions);

  useEffect(() => {
    showMenu();
    dispatch(loadAiProductList());
  }, [dispatch, showMenu]);

  return <AIProductList />;
});

export const SiloProductList = withAuth(() => {
  const dispatch = useDispatch();
  const { showMenu } = useActions(actions);

  useEffect(() => {
    showMenu();
    dispatch(loadAiProductList());
  }, [dispatch, showMenu]);

  return <SiloProductList />;
});

export const LifestyleProductList = withAuth(() => {
  const dispatch = useDispatch();
  const { showMenu } = useActions(actions);

  useEffect(() => {
    showMenu();
    dispatch(loadAiProductList());
  }, [dispatch, showMenu]);

  return <LifestyleProductList />;
});

export const VideoProductList = withAuth(() => {
  const dispatch = useDispatch();
  const { showMenu } = useActions(actions);

  useEffect(() => {
    showMenu();
    dispatch(loadAiProductList());
  }, [dispatch, showMenu]);

  return <VideoProductList />;
});

export const DescriptionProductList = withAuth(() => {
  const dispatch = useDispatch();
  const { showMenu } = useActions(actions);

  useEffect(() => {
    showMenu();
    dispatch(loadAiProductList());
  }, [dispatch, showMenu]);

  return <DescriptionProductList />;
});

const AIProductPage = withAuth(() => {
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      dispatch(loadAiProduct(id));
    }
  }, [dispatch, id]);

  return <AIProduct />;
});

export const AIProductSiloPage = withAuth(() => {
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      dispatch(loadAiProduct(id));
    }
  }, [dispatch, id]);

  return <SiloStep />;
});

export const AIProductBackgroundPage = withAuth(() => {
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      dispatch(loadAiProduct(id));
    }
  }, [dispatch, id]);

  return <BackgroundStep />;
});

export const AIProductVideoPage = withAuth(() => {
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      dispatch(loadAiProduct(id));
    }
  }, [dispatch, id]);

  return <VideoStep />;
});

export const AIProductTextPage = withAuth(() => {
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      dispatch(loadAiProduct(id));
    }
  }, [dispatch, id]);

  return <TextStep />;
});

export const AIProductReviewPage = withAuth(() => {
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      dispatch(loadAiProduct(id));
    }
  }, [dispatch, id]);

  return <ReviewStep />;
});

export const AIProductDownloadPage = withAuth(() => {
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      dispatch(loadAiProduct(id));
    }
  }, [dispatch, id]);

  return <DownloadStep />;
});


export default AIProductPage;
